import React from 'react'
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import { useQuery } from '@apollo/react-hooks'
import blogPostsQueryMultiple from './blogPostsQueryMultiple.gql'
import ArticlesViewer from './Components/ArticlesViewer'
import {
   PROJECT_PAGE_ID,
   GUIDES_PAGE_ID,
   INSPIRATION_PAGE_ID,
} from '../../Core/Util/Constants'
import BlogBanner from '../../Core/Banners/BlogBanner'

const ArticleCategoriesContainer = styled.div`
   background-color: #e9e9e9;
`

const BLOG_ARTICLES_LIMIT_LENGTH = 4

const BlogLanding = ({ category, parents }) => {
   // const [getSetting, loadingSettings] = useSiteSettingsQuery()
   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)
   const categoryId = category?.id

   const { data } = useQuery(blogPostsQueryMultiple, {
      variables: { id: categoryId },
      skip: !categoryId,
   })

   const projectsData = constructArticlesData(data, PROJECT_PAGE_ID)
   const guidesData = constructArticlesData(data, GUIDES_PAGE_ID)
   const inspirationData = constructArticlesData(data, INSPIRATION_PAGE_ID)

   return (
      <>
         <BlogBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
            isSingleBrand={false}
         ></BlogBanner>
         <ArticleCategoriesContainer>
            <ArticlesViewer articlesData={projectsData} />
            <ArticlesViewer articlesData={guidesData} />
            <ArticlesViewer articlesData={inspirationData} />
         </ArticleCategoriesContainer>
         <RenderCustomElements items={items} />
      </>
   )
}

export default BlogLanding

const constructArticlesData = (data, id) => {
   const subCatsArr = data?.category?.subcategories

   const { name, primaryRoute } = subCatsArr?.find(c => c?.id === id) ?? {}
   const articlesArr = subCatsArr?.find(c => c?.id == id)?.subcategories

   const formattedArticlesArr =
      articlesArr?.reduce((accumulator, obj) => {
         accumulator.push({
            id: obj?.id,
            title: obj?.head?.title ? obj?.head?.title : obj?.name,
            articleText: obj?.head?.metaTags[0]?.content,
            imageSrc: obj?.images[3]?.url,
            routePath: obj?.primaryRoute?.path,
         })
         return accumulator
      }, []) ?? []
      
   return {
      name,
      primaryRoute,
      articles: formattedArticlesArr,
   }
}
